import { getKeyedCookieValue } from "asos-site-chrome-store-presentation";

const getCustomerIdFromCookie = () => {
  const customerIdFromCookie = getKeyedCookieValue("asos", "customerid");

  return customerIdFromCookie;
};

export default getCustomerIdFromCookie;
